<template lang="pug">
  aside.main-sidebar.sidebar-dark-primary.elevation-4(style='min-height: 591px;' )
    // Brand Logo
    a.brand-link(href='http://www.contrataciones.gov.py/')
      img.brand-image.img-circle(src='@/assets/images/logo_title.853b35c0.png' alt='Logo DNCP' style='opacity: .8')
      span.brand-text.font-weight-light.align-top
        img(src='@/assets/images/logo_dncp_texto.4e82db80.png' height='25' alt='DNCP')
    // Sidebar
    .sidebar(v-if="show" )
      // Sidebar user (optional)
      .user-panel.mt-3.pb-3.mb-3.d-flex
        .image
        .info
          a.d-block
            | {{ usuario }}
            br
            br
            | {{ uoc }}
      // Sidebar Menu
      nav.mt-2
        ul.nav.nav-pills.nav-sidebar.flex-column(data-widget='treeview' role='menu' data-accordion='false')
          li.nav-item
            a.nav-link(href='/')
              i.fa.fa-search.nav-icon
              p Mis Solicitudes de Información
      // /.sidebar-menu
    // /.sidebar
</template>

<script>
import functions from "../mixins/functions";
import CAS from '../CAS-client'

export default {
name: "Aside",
mixins: [functions],

  data(){
    return{
      usuario: "",
      uoc: "",
      show: true,
    }
  },

  async created() {
    // console.log("aside login " + this._checkLogin())
    // this.show = this._checkLogin()
    // this.usuario = (sessionStorage.getItem("usuario"))
  },
  async mounted() {
    this.usuario = sessionStorage.getItem("nombre_usuario")
    this.uoc = sessionStorage.getItem("uoc_nombre")

    if(!this.usuario) {
      await CAS.getUser()
      this.usuario = sessionStorage.getItem("nombre_usuario")
      this.uoc = sessionStorage.getItem("uoc_nombre")

    }
    this.show = this._checkLogin()
  }
}
</script>

<style scoped>

</style>



